export default "__VITE_ASSET__BaHCdWjb__"